import { render, staticRenderFns } from "./PDSensorsOverview.vue?vue&type=template&id=56722b54&lang=pug"
import script from "./PDSensorsOverview.vue?vue&type=script&lang=js"
export * from "./PDSensorsOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports